export default {
    setRules: (state, data) => {
        console.log(state.rules);
        state.rules = data;
        state.loadingRules = false;
    }
}